import { todayKey } from './format';

/**
 * Renvoie le timestamp ms du prochain minuit local depuis `from`.
 */
export const msUntilNextMidnight = (from: Date = new Date()): number => {
  const next = new Date(from);
  next.setHours(24, 0, 0, 0);
  return next.getTime() - from.getTime();
};

/**
 * Programme un callback à l'instant du prochain minuit local.
 * Retourne une fonction `cancel` pour annuler.
 */
export const scheduleAtNextMidnight = (cb: () => void): (() => void) => {
  const ms = Math.max(1000, msUntilNextMidnight());
  const id = setTimeout(cb, ms);
  return () => clearTimeout(id);
};

export { todayKey };
